module.exports = __webpack_public_path__ + "static/media/icon-message.7a246eee.svg";